// i18n for Javascript
import es from "../../../../../../../ui.apps/src/main/content/jcr_root/apps/barcelo/i18n/es.json";
import en from "../../../../../../../ui.apps/src/main/content/jcr_root/apps/barcelo/i18n/en.json";

export const i18n = function (object) {
  const language = document.documentElement.lang;
  let languageJson;
  if (language === "es-ES") {
    languageJson = es;
  } else if (language === "EN") {
    languageJson = en;
  }
  const objectData = languageJson[object];
  return objectData;
};

export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
export const isAuthor = () => (window.Granite && window.window.Granite.author ? true : false);

export const ellipsisMultiline = (element, lineClamp) => {
  element.style.webkitBoxOrient = "vertical";
  element.style.overflow = "hidden";
  element.style.textOverflow = "ellipsis";
  element.style.display = "-webkit-box";
  element.style.webkitLineClamp = lineClamp ? lineClamp : "4";
};

/**
 * It looks for the class "mod-submenu-open" inside the headerMenu to detect if there is any open submenu and if there is it closes them deleting its class.
 * @param {string} element - Class of the elements where the "mod--submenu-open" class is used to open the menu..
 * @return {void} - Remove mod--submenu-open class
 */
export const handleNavigationMenu = (element) => {
  const headerMenu = document.querySelector(".js-header-menu");
  const navigationMenu = headerMenu?.querySelectorAll(element);
  const hasOpenSubmenus = navigationMenu?.length > 0;
  if (hasOpenSubmenus) {
    navigationMenu.forEach((submenu) => {
      submenu.classList.remove("mod--submenu-open");
    });
  }
};
